import { Link } from "@inertiajs/react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { newMissionPath } from "@/routes"

/**
 * OKS-63 — Cold-start empty state for the cross-mission overview.
 *
 * Renders when `state === "cold_start"` — brand has never had a
 * mission. UX Spec §3 specifies the "Create your first mission" CTA
 * → `newMissionPath()`. Single layout, no variants — `empty_in_window`
 * is handled inline at each surface (trend chart empty card, top-
 * missions empty card) because those surfaces have different copy.
 */
export function AnalyticsOverviewEmpty() {
  const { t } = useTranslation()

  return (
    <Card
      data-testid="analytics-overview-empty"
      className="mx-auto flex max-w-md flex-col items-center gap-4 p-8 text-center sm:p-12"
    >
      <CardContent className="flex flex-col items-center gap-4 p-0">
        <h2 className="text-foreground text-xl font-semibold">
          {t("analytics.empty.cold_start.title")}
        </h2>
        <p className="text-muted-foreground text-sm">
          {t("analytics.empty.cold_start.body")}
        </p>
        <Button asChild>
          <Link href={newMissionPath()} data-testid="analytics-empty-cta">
            {t("analytics.empty.cold_start.cta")}
          </Link>
        </Button>
      </CardContent>
    </Card>
  )
}
